import { SearchQueryParam } from "../entity/types";
import { SkipInt, TakeInt } from "../routes";
import { SearchParams } from "../routes/search";

// copied from https://github.com/sindresorhus/is-absolute-url/blob/master/index.js
export function isAbsoluteUrl(url: string): boolean {
  if (typeof url !== "string") {
    throw new TypeError("Expected a string");
  }

  return /^[a-z][a-z0-9+.-]*:/.test(url);
}

export function isRelativeUrl(url: string): boolean {
  return !isAbsoluteUrl(url);
}

export function searchParamToUrlQuery(
  params: Omit<SearchParams, "take" | "skip"> & {
    address?: string;
    skip?: SkipInt;
    take?: TakeInt;
    includeCount?: boolean;
  }
): Record<string, string> {
  return Object.fromEntries(
    Object.entries({
      [SearchQueryParam.SEARCH_TERM]: params.query,
      [SearchQueryParam.CAUSES]: params.causes,
      [SearchQueryParam.LAT]: params.lat,
      [SearchQueryParam.LNG]: params.lng,
      [SearchQueryParam.ORGANIZATION_SIZE]: params.size,
      [SearchQueryParam.ADDRESS]: params.address,
      [SearchQueryParam.INCLUDE_COUNT]: params.includeCount,
      [SearchQueryParam.DISTANCE]: params.distance,
      [SearchQueryParam.BB_NE_LAT]: params.bbNeLat,
      [SearchQueryParam.BB_NE_LNG]: params.bbNeLng,
      [SearchQueryParam.BB_SW_LAT]: params.bbSwLat,
      [SearchQueryParam.BB_SW_LNG]: params.bbSwLng,
    })
      .filter(([, value]) => !!value)
      .map(([key, value]) => [key, `${value}`])
  );
}
